<template>
  <ol class="multiple-choice-viewer">
    <li
      v-for="(option, i) in moduleData.options.options"
      :key="i"
      class="multiple-choice-viewer__option"
    >
      <!-- Radio select -->
      <NebulaRadio
        v-if="type === 'single'"
        :label-text="option"
      >
        <template #radio>
          <span class="nebula-screenreader-only">
            {{ option.label }},
            {{ option.isCorrect ? $t('correct answer') : $t('incorrect answer') }}
          </span>
          <input
            v-model="response"
            class="nebula-radio"
            :disabled="!userCanEditAttemptQuizItems"
            :name="`${moduleData.id}--options`"
            type="radio"
            :value="`id${i + 1}`"
          >
        </template>
      </NebulaRadio>

      <!-- Checkbox select -->
      <NebulaCheckbox
        v-else
        :label-text="option"
        size="s"
      >
        <template #checkbox>
          <input
            v-model="response"
            class="nebula-checkbox"
            :disabled="!userCanEditAttemptQuizItems"
            :name="`${moduleData.id}--options`"
            type="checkbox"
            :value="`id${i + 1}`"
          >
        </template>
      </NebulaCheckbox>
    </li>
  </ol>
</template>

<script>
import { NebulaCheckbox, NebulaRadio } from '@discoveryedu/nebula-components';
import { get } from 'lodash-es';
import { mapActions, mapState } from 'pinia';
import * as types from '@/lib/constants/store';
import {
  useAssessmentStore,
} from '@/stores';

export default {
  name: 'MultipleChoiceViewer',
  components: {
    NebulaCheckbox,
    NebulaRadio,
  },
  props: {
    moduleData: {
      type: Object, // module data from the store
      required: true,
    },
    type: {
      type: String, // out of ['single', 'multiple']
      required: true,
    },
  },
  computed: {
    ...mapState(useAssessmentStore, [
      'attempt',
      'attemptItemByTeiId',
      'userCanEditAttemptQuizItems',
    ]),
    response: {
      get() {
        const defaultResponse = this.type === 'single' ? '' : [];
        const response = get(this.attemptItemByTeiId(this.teiId), 'try.response');

        // This fallback is outside get() to prevent multiple-response from getting the
        // default '' from the BE
        return response || defaultResponse;
      },
      set(newResponse) {
        this[types.UPDATE_RESPONSE]({
          teiId: this.teiId,
          payload: newResponse,
        });
      },
    },
    teiId() {
      const teiReference = get(this, 'moduleData.references', [])
        .find((ref) => ref.reference_type === 'asset');
      return teiReference && teiReference.reference_id;
    },
  },
  methods: {
    ...mapActions(useAssessmentStore, [
      types.UPDATE_RESPONSE,
    ]),
  },
};
</script>

<style lang="stylus">
.multiple-choice-viewer {
  margin: 0;
  padding: 0;

  &__option {
    list-style-type: none;
  }
}
</style>
